import * as React from 'react';
interface Props{}
const FacebookSocial = (props: Props) => {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="47" height="47" rx="23.5" fill="white" />
            <path
                d="M21.1495 17.8596C21.1495 17.7349 21.1668 17.4657 21.2014 17.0535C21.2386 16.6406 21.3945 16.2086 21.6741 15.7549C21.9511 15.303 22.4005 14.8969 23.0256 14.5376C23.648 14.1801 24.5476 14 25.7215 14H29.0288V17.6042H26.6072C26.3674 17.6042 26.144 17.6942 25.9423 17.8717C25.7423 18.0492 25.6393 18.218 25.6393 18.3747V20.617H29.0279C28.9924 21.056 28.9534 21.4828 28.9084 21.8949L28.7742 22.984C28.7206 23.352 28.666 23.6931 28.6123 24.0074H25.6151V34H21.1495V24.0065H18.9712V20.617H21.1495V17.8596Z"
                fill="black"
            />
            <rect x="0.5" y="0.5" width="47" height="47" rx="23.5" stroke="#EFF4FB" />
        </svg>
    );
};

export default FacebookSocial;
